module.exports = __webpack_public_path__ + "static/media/blog_7.72ea5e78.jpg";